import { useContext } from 'react';
import { CompareContext } from '../context/CompareContext';

export function useCompare() {
    return useContext(CompareContext);
}
